/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name inputnumber
 * @description Text input that limit to numeric input
 * @attr {Number} inputnumber-ratio The unit ratio the value is shown at.
 * @attr {Number} inputnumber-precision The specified number of decimal places to display
 * @attr {Number} inputnumber-min The minimum value to allow
 */
angular.module('mercury.directives.inputnumber', [])
.directive('inputnumber', ["$filter", "$parse", "$timeout", function($filter, $parse, $timeout) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, element, attrs, modelCtrl) {
      var ratio = 1;

      // If no onUpdate is specified, default to blur
      if (!modelCtrl.$options || !modelCtrl.$options.updateOn) {
        modelCtrl.$options = {
          updateOn: 'blur'
        };
      }

      var decimalPrecision = 2;
      if (angular.isDefined(attrs.inputnumberPrecision)) {
        decimalPrecision = parseInt(attrs.inputnumberPrecision, 10);
      }

      // Called to prepare a number for display to a user in the UI.
      function formatModel(modelValue) {

        var value = new BigNumber(modelValue);

        if (value.isNaN()) {
          return '';
        } else {

          // The value stored in the Angular model, and received here as argument, is stored in base
          // units, e.g. for weights that's kg. This function is called to format the number for display
          // in the UI. We need to divide by the ratio to perform a conversion to the value the user is
          // expecting based upon what unit they have specified.
          //
          // E.g. if they've chosen grams as their unit the ratio will be 0.001 as the base unit for
          // weights is kg. Lets say the user has entered 10 grams then the Angular model will actually
          // hold a value of 0.01 (10 x 0.001), however in the UI we want to continue showing the value
          // the user entered, '10'. We do this by dividing 0.01 by the ratio 0.001 (which equals 10)
          // and then formatting that value with the correct number of decimal places.
          //
          // We use bignumber.js for the calculation to get a result as you'd expect on a calculator, avoiding
          // the quirks of floating point arithmetic.
          return value
            .dividedBy(ratio)
            .toFixed(decimalPrecision);
        }
      }

      if (angular.isDefined(attrs.inputnumberRatio)) {
        ratio = $parse(attrs.inputnumberRatio)(scope) || 1;

        scope.$watch(attrs.inputnumberRatio, function(newRatio) {
          ratio = newRatio || 1;

          if (modelCtrl.$valid) {
            modelCtrl.$viewValue = formatModel(modelCtrl.$modelValue);
            modelCtrl.$render();
          }
        });
      }

      // invokes formatModel when the model value changes programatically (e.g. when we get an API response)
      modelCtrl.$formatters.push(formatModel);

      modelCtrl.$validators.valid = function(modelValue) {
        return !isNaN(modelValue);
      };

      // limit to 12 digits due to the database field limitation.
      modelCtrl.$validators.min = function(modelValue) {
        if (angular.isDefined(attrs.min)) {
          return modelValue >= parseFloat(attrs.min);
        } else {
          return modelValue > -999999999999;
        }
      };
      modelCtrl.$validators.max = function(modelValue) {
        return modelValue < 999999999999;
      };

      scope.$watch(attrs.ngModel, function() {
        modelCtrl.$validate();
      });

      modelCtrl.$parsers.push(function(value) {
        var cleanValue = (value || '').replace(/[^\d.-]/g, '');

        if (cleanValue === '' || cleanValue === '-' || cleanValue === '.') {
          cleanValue = 0;
        }

        var parsedValue = new BigNumber(cleanValue);

        // Note - this runs when the user has modified the input value, we
        // receive what they entered and the result of this function is what
        // ends up in the Angular model.
        //
        // The actual value we store in the model can differ from what the user
        // has entered into the input. This happens when the base unit ratio is not '1'.
        //
        // We multiply by the ratio here to convert the user entered value, which is in
        // the units they have chosen for display, into the base unit. We use bignumber.js
        // to ensure that the result is what you'd see on a calculator, e.g. avoiding
        // the quirks of floating point arithmetic.
        //
        // Note that this would be better off using `.toNumber()` but the PATCH
        // stocktake template lines controller is currently not written in such
        // a way to handle numbers being submitted and needs a string.
        return parsedValue.isNaN() ? parsedValue : parsedValue.times(ratio).toString();
      });

      $(element).bind('click', function() {
        $timeout(function() {
          $(element).select();
        }, 5);
      });

      $(element).bind('blur.inputFormatter', function() {
        $timeout(function() {
          modelCtrl.$validate();
          if (modelCtrl.$valid) {
            modelCtrl.$viewValue = formatModel(modelCtrl.$modelValue);
            modelCtrl.$render();
          }
        }, 50);
      });

      element.attr('autocomplete', 'off');
    }
  };
}]);
